import { Stripe, loadStripe } from '@stripe/stripe-js'

import {
  CreateReducer,
  CreateAction,
} from '../../store/utils/store'

import {
  getProjectHandlers,
} from '../../store/utils/api'

import {
  CoconutPPCPaymentsState,
  ReducerHandler,
  ThunkHandler,
} from '../../types/store'

import {
  IQuery_Id,
  IQueryDataId,
} from '@kaidam/fc-shared/src/types/utils'

import {
  IData_CoconutPPCPayments_Status,
  IQuery_CoconutPPCPayments_Subscribe,
  IData_CoconutPPCPayments_Subscribe,
  IData_CoconutPPCPayments_Subscription_With_Priceinfo,
  IData_CoconutPPCPayments_PriceInfo,
} from '@kaidam/fc-shared/src/types/schema/coconut_ppc_payments'

import {
  NetworkThunk,
} from '../utils/network'

import snackbarActions from './snackbar'

const prefix = 'coconut_ppc_payments'

/*

  initial state

*/
const initialState: CoconutPPCPaymentsState = {
  status: null,
  subscriptions: {},
}

/*

  reducers

*/
const setStatus: ReducerHandler<CoconutPPCPaymentsState, IData_CoconutPPCPayments_Status> = (state, action) => {
  state.status = action.payload
}

const setSubscriptions: ReducerHandler<CoconutPPCPaymentsState, Record<string, IData_CoconutPPCPayments_Subscription_With_Priceinfo>> = (state, action) => {
  state.subscriptions = action.payload
}

/*

  thunks

*/

// admin handler to load all threads for the project
const loadOrgStatus: ThunkHandler<IQuery_Id, void> = ({
  id,
}) => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  const data = await handlers.get<IData_CoconutPPCPayments_Status>(`/coconut_ppc_payments/status/${id}`)
  dispatch(actions.setStatus(data))
}

const loadSubscriptions: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  const data = await handlers.get<Record<string, IData_CoconutPPCPayments_Subscription_With_Priceinfo>>(`/coconut_ppc_payments/admin/subscriptions`)
  dispatch(actions.setSubscriptions(data))
}

const subscribe: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  const url = document.location.href
  const data = await handlers.post<IQuery_CoconutPPCPayments_Subscribe, IData_CoconutPPCPayments_Subscribe>(`/coconut_ppc_payments/subscribe`, {
    cancel_url: url,
    success_url: url,
  })
  const stripe = await loadStripe(data.public_key)
  if(!stripe) throw new Error(`stripe client could not be created`)
  const {error} = await stripe.redirectToCheckout({
    sessionId: data.session.id,
  })
  if(error) throw error
}

const updatePriceInfo: ThunkHandler<IQueryDataId<IData_CoconutPPCPayments_PriceInfo>, boolean> = (payload) => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  await handlers.post<IData_CoconutPPCPayments_PriceInfo, void>(`/coconut_ppc_payments/admin/priceinfo/${payload.id}`, payload.data)
  await dispatch(actions.loadSubscriptions())
  dispatch(snackbarActions.setSuccess(`price info updated`))
  return true
}

/*

  collections

*/
const reducers = {
  setStatus,
  setSubscriptions,
}

export const actions = {
  setStatus: CreateAction(prefix, `setStatus`, reducers.setStatus),
  setSubscriptions: CreateAction(prefix, `setSubscriptions`, reducers.setSubscriptions),
  loadOrgStatus: NetworkThunk(prefix, 'loadOrgStatus', loadOrgStatus, {
    snackbar: true,
  }),
  loadSubscriptions: NetworkThunk(prefix, 'loadSubscriptions', loadSubscriptions, {
    snackbar: true,
  }),
  subscribe: NetworkThunk(prefix, 'subscribe', subscribe, {
    snackbar: true,
    globalLoading: {
      message: 'Connecting to stripe...',
    }
  }),
  updatePriceInfo: NetworkThunk(prefix, 'updatePriceInfo', updatePriceInfo, {
    snackbar: true,
    globalLoading: {
      message: 'Updating price info...',
    }
  }),
}

export const reducer = CreateReducer<CoconutPPCPaymentsState>({
  prefix,
  initialState,
  reducers,
})

export default actions
